import { render, staticRenderFns } from "./InstallDescIOS.vue?vue&type=template&id=fe6ba48a&scoped=true"
import script from "./InstallDescIOS.vue?vue&type=script&lang=js"
export * from "./InstallDescIOS.vue?vue&type=script&lang=js"
import style0 from "./InstallDescIOS.vue?vue&type=style&index=0&id=fe6ba48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6ba48a",
  null
  
)

export default component.exports